import React, {useContext} from "react";
import {

    Dropdown,

} from "semantic-ui-react";
import { Col, Row, Empty, Divider, Table} from 'antd';
import FiltroBancoJurado from '../FiltrosComponent/filtroBancoJurado'
import ModalVerJurados1 from "../../../../components/Jurados/Modal/index";
import {TemplateContext} from "../../../../utils/template_context";
import { ReactComponent as IconFlechareg } from "../../../../assets/flecha_reg.svg";
import { itemRenderTable } from "../../../../utils/tablaConvocatoriaHelper";

const TablaJurados = ({setJurados,primeroDatostabla, Tabla, userPermissions, selectFilter, inputFilter, filterByMany }: any) => {

    // State filtro de Estado
    const context = useContext(TemplateContext);



    const [cantidadPaginas, setCantidadPaginas] = React.useState(10);

    const changeValue = (e: any, { value }: any) => {
        console.log(e, value)
        setCantidadPaginas(value)
    }

    // fetch jurados
    
    const cantidadRegistros = [
        {
            key: 1,
            value: 10,
            text: "10",
        },
        {
            key: 2,
            value: 20,
            text: "20",
        },
        { key: 3, value: 50, text: "50" },
        { key: 4, value: 100, text: "100" },
    ];

    const columns: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                        <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },

        {
            title: "Nombre y apellido",
            width: 300,
            render: (datos: any) => {
                return (
                    <>
                        {datos.primer_nombre}{" "} {datos.segundo_nombre}{" "}
                        {datos.primer_apellido}{" "} {datos.segundo_apellido}
                    </>
                );
            },

        },


        { 
            hidden: userPermissions ? false : true,
            title: "Nro documento",
            width: 140,
            dataIndex: "numero_documento",
            key: "numero_documento",
        },
        {
            title: "Código",
            width: 120,
            dataIndex: "id_jurado",
            key: "id_jurado",
        },
        {
            title: "Estado",
            width: 120,
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Expresiones",
            width: 169,
            render: (datos: any) => {
        
                
                return (
                    <>
                        {datos.areas_conocimientos?.map((areas_conocimientos: any, index: number) => {
                        return (
                            
                            areas_conocimientos && (
                                <p className="font-size-12px font-family-Work-Sans">
                                {areas_conocimientos.area_principal}
                            </p>
                            ))
                    })}                   
                  
                    </>         
                        
                  
                );
            },
        },
        {
            title: "Categoría",
            width: 669,
            render: (datos: any) => {
                return (
                    <>

                      { datos?.areas_conocimientos?.map((conocimientos: any)=>
                         
                            conocimientos.areas_conocimientos?.map((datos_conocimientos: any,i)=>  
                            (  <span key={datos_conocimientos?.nombre} style={{fontFamily:'Work-Sans-Regular'}}> {datos_conocimientos?.nombre} / </span>)
                            )
                         )
                         } 

                    </>
                );
            },
        }, 
        {
            title: () => (
                <Row className="width-100">
                    <Col span={24} className="justify-content-center">
                        Acciones
                    </Col>
                </Row>
            ),
            width: 90,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any) => (
                    <Row className="width-100">
                        <Col span={24} className="justify-content-center">
                            <ModalVerJurados1 setJurados={setJurados} primeroDatostabla={primeroDatostabla} handleObservacion={null} observacionData={null} changeState={null} buttonPostulation={null} datos={datos} userState={userPermissions} />
                        </Col>
                    </Row>
            ),
        },
    ];

    // console.log(arrayJurados)

    return (
        <div className="h-100">
            <div className="container-fluid ps-md-4 pe-md-4 main-c7">
                <Row className="row-shadow mt-3 mb-3">
                    <Row className="width-100" style={{ paddingLeft: "2%", paddingRight: "2%" }}>
                        <FiltroBancoJurado filterByMany={filterByMany} selectFilter={selectFilter} inputFilter={inputFilter} primerosDatosTabla={primeroDatostabla} />
                        <Divider style={{ marginBottom: "16px", marginTop: "10px" }} />
                        <Row className="width-100">
                            <Col span={19} className="font-size-14px font-family-Montserrat-SemiBold" style={{ paddingBottom: "0%" }}>
                                Gestionar postulación de jurados
                            </Col>
                            <Col span={2} className="justify-content-center">
                                {/* Total : <span className="font-color-F28C02">{totalregistros}</span> */}
                            </Col>
                            <Col span={3} style={{ display: "flex", flexDirection: "row" }}>
                            <span style={{ flex: 0.7 }} className="font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                                Registros por página
                            </span>
                                <Dropdown
                                    fluid
                                    style={{ flex: 0.3 }}
                                    className="select-registros-adminconvocatoria no-margin"
                                    defaultValue={cantidadPaginas}
                                    options={cantidadRegistros}
                                    icon={<IconFlechareg/>
                    }
                                    /* onChange={(e, { value }) => setCantidadPaginas(e, {value})} */
                                    onChange={changeValue}
                                />
                            </Col>
                        </Row>
                        <Row className="width-100">
                            <Col span={24}
                            >
                                <Table
                                    locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                    pagination={{ position: ["bottomRight"], itemRender: itemRenderTable, pageSize: cantidadPaginas }}
                                    dataSource={Tabla}
                                    columns={columns.filter((i:any) => !i?.hidden)}
                                    size="small"
                                    className="tab-pane-jurados"
                                    bordered={false}
                                    scroll={{ x: 1300 }}
                                />
                            </Col>
                        </Row>
                    </Row>
                </Row>

            </div>
        </div>

    )
}
export default TablaJurados




























